/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_OrInputs */

const en_common_sign_or = /** @type {(inputs: Common_Sign_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or continue with`)
};

const zh_common_sign_or = /** @type {(inputs: Common_Sign_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`或者继续使用`)
};

/**
* | output |
* | --- |
* | "Or continue with" |
*
* @param {Common_Sign_OrInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_or = /** @type {((inputs?: Common_Sign_OrInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_OrInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_or(inputs)
	return zh_common_sign_or(inputs)
});
export { common_sign_or as "common.sign.or" }